import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Field } from "formik";
import { CheckboxWithLabel } from "formik-mui";
import QuestionTextField from "./QuestionTextField";

const LongAnswerFields = ({ questionFilesList, setQuestionFilesList }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      data-qa="admin-content-long-answer-container"
    >
      <QuestionTextField
        questionFilesList={questionFilesList}
        setQuestionFilesList={setQuestionFilesList}
      />
      <Box mb={4} mt={3} flex={1} display="flex">
        <Field
          component={CheckboxWithLabel}
          name="additionalOptions.allowHtml"
          inputProps={{
            "data-qa": "enable-html-editor-checkbox"
          }}
          Label={{
            label: (
              <Typography variant="subtitle1">
                {t("editQuestion.enableHtmlLabel")}
              </Typography>
            )
          }}
          color="primary"
          type="checkbox"
        />
      </Box>
    </Box>
  );
};

LongAnswerFields.propTypes = {
  questionFilesList: PropTypes.array,
  setQuestionFilesList: PropTypes.func
};

export default LongAnswerFields;
